import {
	KDataTable,
	KDataTableMenu
} from "kinnect-general";
import {
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";

export default KDataTable.extend( {
	name: "KDriversStatusTable",

	props: {
		noDataText: {
			...KDataTable.options.props.noDataText,
			default: "There are no drivers to display"
		},

		noResultsText: {
			...KDataTable.options.props.noResultsText,
			default: "No matching drivers found"
		},

		sortBy: {
			...KDataTable.options.props.sortBy,
			default: "user.name"
		}
	},

	data: () => ( {
		statusClassMap: {
			"Assigned": "blue lighten-5 black--text",
			"Available": "light-green darken-2 white--text",
			"Loading": "blue lighten-3 black--text",
			"Off": "grey white--text",
			"On Break": "red darken-1 white--text",
			"On Route": "blue darken-1 white--text",
			"Pending": "amber lighten-2 black--text"
		}
	} ),

	computed: {
		showActionsCol() {
			return this.$can( "edit_yard_drivers" );
		},

		defaultHeaders() {
			return [
				{
					text: "Name",
					value: "user.name"
				},
				{
					text: "CDL",
					value: "cdl"
				},
				{
					text: "Status",
					value: "status"
				},
				this.showActionsCol && {
					align: "end",
					sortable: false,
					text: this.isMobile ? "Actions" : "",
					value: "actions"
				}
			];
		}
	},

	methods: {
		updateDriverBreak( driver, onBreak ) {
			driver.onBreak = onBreak;
			driver.save();
		}
	},

	render() {
		return <KDataTable
			attrs={this.$props}
			headers={this.$_headers}
			on={{ ...this.$listeners }}
			scopedSlots={{
				item: ( { item } ) =>
					<tr
						class={this.statusClassMap[item.status]}
						key={item.id}
					>
						{this.isColVisible( "user.name" ) && <td>{item.user.name}</td>}

						{this.isColVisible( "cdl" ) && <td>
							<VIcon style="color: inherit;">{item.cdl ? "done" : "clear"}</VIcon>
						</td>}

						{this.isColVisible( "status" ) && <td>{item.status}</td>}

						{this.isColVisible( "actions" ) && <td>
							<KDataTableMenu>
								<VList>
									<VListItem
										to={{
											name: "yardDriver",
											params: { idDriver: item.id }
										}}
									>
										<VListItemAction>
											<VIcon>visibility</VIcon>
										</VListItemAction>

										<VListItemContent>
											<VListItemTitle>View</VListItemTitle>
										</VListItemContent>
									</VListItem>

									{item.onBreak
										? <VListItem onClick={() => this.updateDriverBreak( item, false )}>
											<VListItemAction>
												<VIcon>alarm_off</VIcon>
											</VListItemAction>

											<VListItemContent>
												<VListItemTitle>End Break</VListItemTitle>
											</VListItemContent>
										</VListItem>
										: <VListItem onClick={() => this.updateDriverBreak( item, true )}>
											<VListItemAction>
												<VIcon>alarm_on</VIcon>
											</VListItemAction>

											<VListItemContent>
												<VListItemTitle>Start Break</VListItemTitle>
											</VListItemContent>
										</VListItem>
									}
								</VList>
							</KDataTableMenu>
						</td>}
					</tr>,

				...this.$scopedSlots
			}}
		></KDataTable>;
	}
} );
